/**
 * Loosely typed translation helper for identifiers that arrive from the server (permission ids,
 * event types). Keys are checked by the locale-equality test and by the components' own tests.
 */
export type Translate = (key: string, options?: Record<string, unknown>) => string;

export function permissionLabel(t: Translate, permission: string): string {
  return t(`permissions.${permission}`);
}

export function permissionGroupLabel(t: Translate, group: string): string {
  return t(`permissionGroups.${group}`);
}
